__turbopack_context__.v({
  "skuOverlay": "Slider4-module__5ZbPWa__skuOverlay",
  "thumbSlide": "Slider4-module__5ZbPWa__thumbSlide",
  "thumbSwiper": "Slider4-module__5ZbPWa__thumbSwiper",
  "thumbnailWrap": "Slider4-module__5ZbPWa__thumbnailWrap",
});
